import { get, post } from '../client/client';
import { endpoint } from '../endpoint';
import type { PageQuery } from '../type/payment';
import type { BalanceListResponse, BalancePaymentCreate, MemberBalancePublic } from '../type/balance';

export const getBalances = async (params: PageQuery) => {
  return await get<BalanceListResponse>(endpoint.getBalances, { params });
};

export const getBalance = async (userId: number) => {
  return await get<MemberBalancePublic>(endpoint.getBalance(userId));
};

export const createBalancePayment = async (userId: number, payload: BalancePaymentCreate) => {
  return await post<MemberBalancePublic, BalancePaymentCreate>(endpoint.createBalancePayment(userId), payload);
};
